module.exports = __webpack_public_path__ + "static/img/row6.f63e34e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark-mini/row6.png
// module id = jcRA
// module chunks = 12